import { Component, Inject, Input, OnChanges, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DirectionService } from '../../../shared/services/direction.service';
import { environment } from 'src/environments/environment';
import { isPlatformServer } from '@angular/common';
import { BRAND } from 'src/app/shared/brand';
import { CultureService } from 'src/app/shared/culture/culture.service';

/// The home page's hero, from its "home.hero" fragment: the page's heading and the line under it, then the slides -
/// each a sentence and the link its button follows.
export interface SlideshowHero {
    heading: string;
    sub: string;
    slides: { text: string; link: { text: string; url: string } | null }[];
}

const IMAGES = {
    image_classic: 'assets/images/slides/primehat-welcome.webp',
    image_full: 'assets/images/slides/primehat-welcome.webp',
    image_mobile: 'assets/images/slides/primehat-welcome-mobile.webp',
    image_mobile_sm: 'assets/images/slides/primehat-welcome-mobile.webp',
    background: 'linear-gradient(to right, var(--ph-primary-deep), var(--ph-promo-to))',
};

@Component({
    selector: 'app-block-slideshow',
    templateUrl: './block-slideshow.component.html',
    styleUrls: ['./block-slideshow.component.scss']
})
export class BlockSlideshowComponent implements OnChanges {
    @Input() withDepartments = false;
    /// The owner's words for the slides (the home page passes its "home.hero" fragment). Without them, one placeholder
    /// slide with the shop's tagline.
    @Input() hero: SlideshowHero = null;

    options = {
        nav: false,
        dots: false,
        dotsEach:1,
        rewind:true,
        autoplay:environment.production,
        autoplayTimeout:10000,
        autoplayHoverPause:true,
        lazyLoad:false,
        responsive: {
            0: {items: 1}
        },
        rtl: this.direction.isRTL()
    };
    slideOne:any;
    isServer:boolean = false;

    // The placeholder until the owner's hero arrives: the shop's line (the tagline), which the server render also
    // uses as the home page's H1, on a banner in the theme's colours.
    slides: any[] = [
        {
            ...IMAGES,
            title: this.culture.t('primehat-tagline', 'Shop from Verified Sellers Across Bangladesh'),
            text: '',
            link: "/products",
            iswhite: true
        }
    ];

    slideBackgroundColor:string = this.slides[0].background

    constructor(
        public sanitizer: DomSanitizer,
        private direction: DirectionService,
        @Inject(PLATFORM_ID) private platformId: any,
        private culture: CultureService,
    ) { this.slideOne = this.slides[0]; this.isServer = isPlatformServer(this.platformId);}

    /// The hero's slides on the same picture: first the page's heading and the line under it (the H1, which the server
    /// render draws alone), then each slide's sentence with its button.
    ngOnChanges(): void {
        if (!this.hero || !this.hero.heading) {
            return;
        }
        this.slides = [
            { ...IMAGES, title: this.hero.heading, text: this.hero.sub, link: '/products', button: '', heading: true, iswhite: true },
            // A slide is one link (the router's): its button goes to a page of the site.
            ...this.hero.slides.filter(slide => slide.text).map(slide => ({
                ...IMAGES,
                title: slide.text,
                text: '',
                link: slide.link && /^\/(?![\/\\])/.test(slide.link.url) ? slide.link.url : '/products',
                button: slide.link ? slide.link.text : '',
                heading: false,
                iswhite: true,
            })),
        ];
        this.slideOne = this.slides[0];
        this.slideBackgroundColor = this.slides[0].background;
    }

    caroChanged(e:any)
    {
        this.slideBackgroundColor = this.slides[e.startPosition].background;
    }
}
